import React, {PureComponent} from 'react';
import { withTranslation } from 'react-i18next';
import {Link} from "react-router-dom";

import PageTitle from "../../components/Commons/PageTitle";
import Helpbox from "../../components/UI/Helpboxes/Helpbox"
import Tabs from "../../components/UI/Tabs/Tabs";
import Spinner from "../../components/UI/Spinner";

import ManageAccount from './ManageAccount/ManageAccountRefactored'
import Assignments from "../../components/Profile/Assignments";
import CardsList from "../../components/Profile/SavedPaymentMethods/Cards/List";
import BanksList from "../../components/Profile/SavedPaymentMethods/Banks/List";
import PaymentBox from "../../components/Profile/SavedPaymentMethods/Payment/Box";
import UserContext from '../../context/user-context';
import Notifications from "../../components/Profile/Notifications/Notifications";
import Messages from "../../components/Profile/Messages/Messages";
import {userHaveSpecificPermission} from "../../components/Utils/UserHelper";

class Profile extends PureComponent {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        let activeTab = window.location.pathname.split('/')[2];
        this.state = {
            loading: false,
            activeTab: activeTab,
        }
    }

    resetOverrideTab = () => {
        window.history.pushState({}, null, '/profile');
    }


    render() {
        const user = this.context.user;
        let permission,role,paymentType;

        if (user.infos) {
            permission = user.infos.permission
            role = user.infos.role

			paymentType = '';
			if (user?.account?.hasPreAuthorizedAccount) {
				const code = user.account.classification.code;
				if (code !== 'RES') {
					paymentType = 'ppa';
				} else {
					paymentType = 'budget';
				}
			}

        }

        const {
            activeTab
        } = this.state;

        const cardListPermissions = {add:true,delete:true};
        const bankListPermissions = {add:true,delete:true};

        const updateNotifHeader = this.props.updateUserNotif;

        return (
            <div className="container container--larger">
                <div className="row flex flex--wrap flex--align-baseline">
                    <div className="col-lg-5">
                        <PageTitle title={this.props.t("profile.yourprofile")}/>
                    </div>
					{userHaveSpecificPermission(user, 'financial_data') && (user.infos && user.infos.permission !== 'limited') ?
                    <div className="col-lg-7">
                        <Helpbox type="invoice" cta={true}/>
                    </div>
					: null }
                </div>

                <div>
                    <Tabs
                        activeTab={activeTab}
                        currentTab={activeTab}
                        reset={this.resetOverrideTab}
                    >
                        <div label={this.props.t("profile.manageaccount")} tabkey="manage">
                            <div>
                                <h2 className="headline headline--section headline--uppercase">{this.props.t("profile.manageprofile")}</h2>
                                <ManageAccount />
                            </div>
                        </div>
                        {role === 'owner'?
                            (<div label={this.props.t("profile.employes")} tabkey="assignments">
                                <Assignments />
                            </div>)
                            :null}
                        {userHaveSpecificPermission(user, 'financial_data') && (user.infos && user.infos.permission !== 'limited') ?
                            (<div label={this.props.t("profile.payment_methods")} tabkey="payment_methods">
								{(user && user.account) ? (
									<>
										{(paymentType && user.infos && user.infos.permission !== 'limited') ?
											(<PaymentBox paymentType={paymentType}/>) :
											(
												<>
													{!user.account.hasPreAuthorizedAccount &&
                                                      user.infos && user.infos.permission !== 'limited' &&
														<Helpbox type={user.account.classification.code !== 'RES' ? 'ppa' : 'budget'} cta={true} text={true}
																 classes="helpbox--in-profile mb-5"/>
													}

												</>
											)}

									</>
								) : null}
								<hr/>
								<>
									{user.paymentCardAllowed && <CardsList from={'profile'} can={cardListPermissions}/>}
									{user.paymentCardAllowed && user.paymentEftAllowed && <hr/>}
									{user.paymentEftAllowed && <BanksList from={'profile'} can={bankListPermissions}/>}
								</>
							</div>)
							: null
                        }
                        <div label={this.props.t("profile.notifications.title")} tabkey="notifications">
                            <Notifications />
                        </div>
                        <div label="Notifications" tabkey="messages">
                            <Messages updateNotifHeader={updateNotifHeader}/>
                        </div>
                        <div label={this.props.t("profile.addresses")} hidden tabkey="manage3">
                            <div>PHASE 2 ( HIDDEN )</div>
                        </div>
                    </Tabs>
                </div>
                <Helpbox cta={true}/>
            </div>
        );
    }
}

export default withTranslation()(Profile);

